import React from "react";

export const AsyncPageNotFound = React.lazy(
  () => import("../layout/PageNotFound")
);

export const AsyncProfileListPage = React.lazy(
  () => import("../layout/ProfileListPage")
);

export const AsyncProfile = React.lazy(() => import("../layout/ProfilePage"));

export const AsyncAml = React.lazy(() => import("../layout/AmlSearchPage"));

export const AsyncNavBar = React.lazy(() => import("../components/Navbar"));

export const AsyncAmlDetails = React.lazy(() => import("../layout/AmlPage"));

export const AsyncCreateProfile = React.lazy(
  () => import("../layout/CreateProfilePage")
);

export const AsyncProfileExport = React.lazy(
  () => import("../layout/ProfileExportPage")
);

export const AsyncAddAmlSearchToProfile = React.lazy(
  () => import("../layout/AddAmlSearchToProfilePage")
);

export const AsyncGlobalAudits = React.lazy(
  () => import("../layout/GlobalAuditsPage")
);

export const AsyncMonitor = React.lazy(() => import("../layout/Monitor"));

export const AsyncUploads = React.lazy(() => import("../layout/UploadsPage"));

export const AsyncAmlCheck = React.lazy(
  () => import("../layout/AmlCheck")
);

export const AsyncReports = React.lazy(
  () => import("../layout/GenerateReports")
);

export const AsyncSettings = React.lazy(() => import("../layout/SettingsPage"));
